import React from 'react';
import { useTranslation } from "react-i18next";
import { Grid } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import DyanamicDropdown from 'components/Elements/DynamicDropdown';
import { useFilters } from '../FilterContext';
import { useFilterInitialization } from './hooks/useFilterInitialization';
import { SHOW_ALL_OPTION } from '../constants';

export const WorkOrderFilter = () => {
  const { t } = useTranslation();
  const { filterValues, updateFilter } = useFilters();

  // Fixed: Changed boolean IDs to strings for URL persistence compatibility
  const workOrderOptions = [
    SHOW_ALL_OPTION,
    { id: 'true', name: t("option.assigned") },
    { id: 'false', name: t("option.unassigned") },
  ];

  // Clean, declarative initialization
  useFilterInitialization('workOrder', workOrderOptions, {
    waitForData: false,
    getDefaultValue: () => SHOW_ALL_OPTION,
    getParams: (item) => ({ notificationRaised: item.id })
  });

  if (!filterValues.workOrder) {
    return null;
  }

  return (
    <Grid item lg={3} md={6} xs={12}>
      <DyanamicDropdown
        dataSource={workOrderOptions}
        columns={[{ name: 'name', id: 1 }]}
        showHeader={false}
        width="100%"
        placeholder={t("placeholder.selectWorkOrderStatus")}
        onChange={item => updateFilter('workOrder', item, { notificationRaised: item.id })}
        selectdValueToshow="name"
        selectedValue={filterValues.workOrder?.value}
        label={t("label.filterByWorkOrderStatus")}
        icon={<FilterListIcon style={{ color: 'rgb(48,122,215)' }} />}
        required={false}
        showBorderColor
      />
    </Grid>
  );
}; 
